import React from 'react';
import { Link } from 'react-router-dom';
import './card.css';

export default function Card({
	image,
	title,
	link,
	width = '300px',
	height = '200px',
	imageHeight = '150px',
	style = {},
	imageStyle = {},
	clickable = true,
	onClick,
}) {
	const cardStyles = {
		width: width,
		height: height,
		...style,
	};

	const cardImageStyles = {
		height: imageHeight,
		...imageStyle,
	};

	const handleClick = (e) => {
		if (onClick) {
			e.preventDefault();
			onClick(e);
		}
	};

	const CardContent = () => (
		<>
			<div className="card-image" style={cardImageStyles}>
				<img src={image} alt={title || 'Card image'} />
			</div>
			{title && (
				<div className="card-content">
					<div className="card-title">{title}</div>
				</div>
			)}
		</>
	);

	if (!clickable) {
		return (
			<div className="card card-non-clickable" style={cardStyles}>
				<CardContent />
			</div>
		);
	}

	if (onClick && !link) {
		return (
			<div
				className="card card-clickable"
				style={cardStyles}
				onClick={handleClick}
				role="button"
				tabIndex={0}
				onKeyPress={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						handleClick(e);
					}
				}}
			>
				<CardContent />
			</div>
		);
	}

	return (
		<div className="card" style={cardStyles}>
			<Link to={link} className="card-link" onClick={handleClick}>
				<CardContent />
			</Link>
		</div>
	);
}
